import { dayjs } from 'element-plus'
import { apiUserResource, getInfo } from './user'
import { apiUtil } from 'lifesci-ui'

const { getApiPathPrefix, request } = apiUtil

const csaAdminBasePath = () => {
  return `${getApiPathPrefix('VUE_APP_BASE_PATH_CSA_ADMIN')}`
}

const animalBasePath = () => {
  return `${getApiPathPrefix('VUE_APP_BASE_PATH_ANIMAL')}`
}

export function initDic(token) {
  getDic(2).then(response => {
    setDic('dicSpecies', response)
  })
  getDic(3).then(response => {
    setDic('dicStrain', response)
  })
  getDic(4).then(response => {
    setDic('dicVendor', response)
  })

  getDic(10).then(response => {
    setDic('dicGender', response)
  })
  getDic(11).then(response => {
    setDic('dicOrderStatus', response)
  })
  getDictSite().then(response => {
    setDic('dicSite', response)
  })

  listDepartment().then(response => {
    setDic('dicDepartment', response.records)
  })

  getDic(15).then(response => {
    setDic('dicProtocolStatus', response)
  })
  getDic(16).then(response => {
    setDic('dicAgeUnit', response)
  })
  getDic(17).then(response => {
    setDic('dicWeightUnit', response)
  })
  getDic(40).then(response => {
    setDic('dicCheckType', response)
  })
  getDic(41).then(response => {
    setDic('dicClinicalSign', response)
  })

  getDic(43).then(response => {
    setDic('dicRack', response)
  })

  getDic(111).then(response => {
    setDic('dicProtocolSource', response)
  })

  getDic(112).then(response => {
    setDic('dicHealthCheckStatus', response)
  })

  getDic(113).then(response => {
    setDic('dicEuthanasiaMethod', response)
  })

  listTenant().then(response => {
    const data = []
    for (const i of response) {
      if (String(i.deleted) === '0' || !i.deleted) {
        const row = {
          term: i.name,
          contentId: i.id,
          isDeleted: 'N'
        }
        data.push(row)
      }
    }

    setDic('tenants', data)
  })

  getInfo(token).then(data => {
    if (!data) {
      reject('Verification failed, please Login again.')
    }

    const { roles, name, avatar, introduction } = data

    // roles must be a non-empty array
    if (!roles || roles.length <= 0) {
      return
    }
    sessionStorage.setItem('user', data.name)
    sessionStorage.setItem('userId', data.userId)
    sessionStorage.setItem('site', data.siteId)
    sessionStorage.setItem('siteName', data.site)
    sessionStorage.setItem('group', data.groupId)
    sessionStorage.setItem('department', data.departmentId)
    sessionStorage.setItem('account', data.account)
    sessionStorage.setItem('roles', JSON.stringify(data.roles))
    sessionStorage.setItem('tenantId', data.tenantId)

    if (data.userId) {
      apiUserResource(data.userId).then(ret => {
        setDic('resource', ret)
      })
    }

    // commit('SET_ROLES', roles)
    // commit('SET_NAME', name)
    // commit('SET_AVATAR', avatar)
    // commit('SET_INTRODUCTION', introduction)
  })
}



function setDic(dicName, val) {
  localStorage.setItem(dicName, JSON.stringify(val))
}



export function getStorageDic(name) {
  return JSON.parse(localStorage.getItem(name))
}


export function getDic(categoryId) {
  return request({
    url: animalBasePath() + '/dic?categoryId=' + categoryId,
    method: 'get'
  })
}
export function listDictCategory() {
  return request({
    url: animalBasePath() + '/listDictCategory',
    method: 'get'
  })
}




export function listStudy(projectId) {
  return request({
    url: animalBasePath() + '/listStudy',
    method: 'get',
    params: { projectId }
  })
}

export function listUser() {
  return request({
    url: animalBasePath() + '/listUser',
    method: 'get'
  })
}

export function listSameTenantUser(userId) {
  return request({
    url: animalBasePath() + '/listSameTenantUser',
    method: 'get',
    params: { userId }
  })
}

export function getUser(userId) {
  return request({
    url: animalBasePath() + '/getUser',
    method: 'get',
    params: { userId }
  })
}


export function getStudy(studyId) {
  return request({
    url: animalBasePath() + '/getStudy',
    method: 'get',
    params: { studyId }
  })
}



export function getDictSite() {
  return request({
    url: animalBasePath() + '/getDictSite',
    method: 'get'
  })
}



export function listDepartment() {
  return request({
    url: csaAdminBasePath() + '/group/page',
    method: 'post',
    data: {
      onlyDepartment: true
    }
  })
}
export function listProject() {
  return request({
    url: animalBasePath() + '/listProject',
    method: 'get'
  })
}

export function listTenant() {
  return request({
    url: animalBasePath() + '/listTenant',
    method: 'get'
  })
}

export function getProjectByStudy(studyId) {
  return request({
    url: animalBasePath() + '/getProjectByStudy',
    method: 'get',
    params: { studyId }
  })
}


export function getAttach(id) {
  return request({
    url: animalBasePath() + '/attach/get',
    method: 'get',
    params: { id }
  })
}

export function listAttach(type) {
  return request({
    url: animalBasePath() + '/attach/list',
    method: 'post',
    data: type
  })
}

export function downloadAttach(id) {
  return request({
    url: animalBasePath() + '/attach/download',
    method: 'get',
    params: { id }
  })
}
export function attachDownloadLog(data) {
  return request({
    url: animalBasePath() + '/attach/download/log',
    method: 'post',
    data: data
  })
}

export function deleteAttach(id) {
  return request({
    url: animalBasePath() + '/attach/delete',
    method: 'get',
    params: { id }
  })
}

export function getPercentage(num1, num2) {
  if (!num1) {
    num1 = 0
  }
  if (!num2) {
    return ''
  }
  if (num2 <= 0) {
    return '0%'
  } else {
    return ((defaultNum(num1) / num2) * 100).toFixed(2) + '%'
  }
}

export function dateChange(num = 1, date = false) {
  if (!date) {
    date = new Date()// 没有传入值时,默认是当前日期
    date = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
  }
  date += ' 00:00:00'// 设置为当天凌晨12点
  date = Date.parse(new Date(date)) / 1000// 转换为时间戳
  date += (86400) * num// 修改后的时间戳
  var newDate = new Date(parseInt(date) * 1000)// 转换为时间
  return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()
}

export function monthChange(num = 0, date) {
  if (!date) {
    return ''
  }
  const newDate = new Date(date)

  newDate.setMonth(newDate.getMonth() - num)
  return newDate.getFullYear() + '-' + (newDate.getMonth() + 1) + '-' + newDate.getDate()
}

export function defaultNum(val) {
  if (val) {
    return val
  } else {
    return 0
  }
}

export function isAdmin() {
  const roles = JSON.parse(sessionStorage.getItem('roles'))
  if (roles.includes('admin')) {
    return true
  }
  return false
}

export function isAdminOrTenantEditor() {
  const roles = JSON.parse(sessionStorage.getItem('roles'))
  for (const role of roles) {
    if (role === 'admin' || role === 'tenant-editor') {
      return true
    }
  }
  return false
}

export function isEditor() {
  const roles = JSON.parse(sessionStorage.getItem('roles'))
  if (roles.includes('animal-editor')) {
    return true
  }
  return false
}



export function getImageSrc(src) {
  if (!src) {
    return ''
  }
  if (src.indexOf('http') === 0) {
    return src
  }

  if (src.indexOf('data:image') === 0) {
    return src
  }
  if (src.indexOf('blob:http') === 0) {
    return src
  }

  return 'data:image;base64,' + src
}

export function formatTime(val) {
  const date = new Date(val)
  if (date instanceof Date && !isNaN(date.getTime())) {
    return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return ''
  }
}

export function formatDate(val, format) {
  if (!format) {
    format = 'YYYY-MM-DD'
  }
  const date = new Date(val)
  if (date instanceof Date && !isNaN(date.getTime())) {
    return dayjs(date).format(format)
  } else {
    return ''
  }
}

export function getPreMonth(date) {
  if (!date) {
    date = new Date()
  }
  var lastMonthDate = ''
  // 获取当前几号，如果小于10则补0
  var day = date.getDate()
  if (day < 10) {
    day = '0' + day
  }
  var month = date.getMonth()
  var year = date.getFullYear()
  // 上个月小于1则证明跨年，年份减1
  if (month < 1) {
    lastMonthDate = year - 1 + '-12-' + day
  } else {
    // 月份小于10则补0
    if (month < 10) {
      month = '0' + month
    }
    lastMonthDate = year + '-' + month + '-' + day
  }
  return lastMonthDate + ' 00:00:00'
}

export function yearFilter(year) {
  const date1 = new Date(year, 0, 1)
  date1.setMonth(0)
  date1.setDate(1)
  const date2 = new Date(year + 1, 0, 0)
  const thisYear = {
    column: {
      value: 'request_date'
    },
    filter: {
      condition: 'between',
      valueList: [formatDate(date1), formatDate(date2)]
    }
  }
  return thisYear
}

export function colToFilter(tableColumns) {
  const newFilter = []
  for (const i of tableColumns) {
    if (!i.column || !i.column.value || !i.filter) {
      continue
    }
    if (!i.filter.valueList) {
      i.filter.valueList = []
    }

    if (!i.filter.value && i.filter.valueList.length <= 0) {
      continue
    }

    const col = {
      column: {
        value: i.column.value
      },
      filter: {
        condition: i.filter.condition,
        type: i.filter.type,
        value: i.filter.value,
        valueList: i.filter.valueList
      }
    }

    if (i.filter.type === 'input-year') {
      let year = new Date().getFullYear()
      if (typeof (i.filter.value) === 'string') {
        year = Number(i.filter.value.slice(0, 4))
      } else {
        year = i.filter.value.getFullYear()
      }
      const thisYear = yearFilter(year)
      newFilter.push(thisYear)
    } else {
      newFilter.push(col)
    }
  }
  return newFilter
}

export function openwin(url) {
  var a = document.createElement('a')
  a.setAttribute('href', url)
  a.setAttribute('target', '_blank')
  a.setAttribute('id', 'camnpr')
  document.body.appendChild(a)
  a.click()
}
